import React, { useState, useEffect } from 'react';
import myAxios from '../AxiosUrl';
import styles from './Dashboard.module.css';

function Dashboard() {
    const uid = localStorage.getItem('id');
    const [dashboard, setDashboard] = useState([]);
    const [loadingDash, setLoadingDash] = useState(false);

    // City data
    const [city, setCity] = useState([]);
    const [LoadingCity, setLoadingCity] = useState(false);
    // Top 5 Cities period (it was today only, so the card was usually empty)
    const [cityPeriod, setCityPeriod] = useState('30d');

    // All period data
    const [dashToday, setDashToday] = useState([]);
    const [dashYesterday, setDashYesterday] = useState([]);
    const [dashMonth, setDashMonth] = useState([]);
    const [dashLastMonth, setDashLastMonth] = useState([]);

    const [loadingDay, setLoadingDay] = useState(false);
    const [loadingYes, setLoadingYes] = useState(false);
    const [loadingMonth, setLoadingMonth] = useState(false);
    const [loadingLMonth, setLoadingLMonth] = useState(false);

    // Visitor data
    const [VisitToday, setVisitToday] = useState([]);
    const [VisitYesterday, setVisitYesterday] = useState([]);
    const [VistMonth, setVistMonth] = useState([]);
    const [VisitLastMonth, setVisitLastMonth] = useState([]);
    const [loadingVDay, setloadingVDay] = useState(false);
    const [loadingVYes, setloadingVYes] = useState(false);
    const [loadingVMonth, setloadingVMonth] = useState(false);
    const [loadingVLMonth, setloadingVLMonth] = useState(false);

    // Message data
    const [message, setMessage] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState(false);

    // Top selling & low stock
    const [topSelling, setTopSelling] = useState([]);
    const [loadingTopSelling, setLoadingTopSelling] = useState(false);
    const [lowStock, setLowStock] = useState([]);
    const [loadingLowStock, setLoadingLowStock] = useState(false);

    // Fetch inventory data
    useEffect(() => {
        setLoadingDash(true);
        myAxios
            .get(`dashboard/${uid}`)
            .then((res) => {
                setLoadingDash(false);
                setDashboard(res.data);
            })
            .catch((err) => {
                setLoadingDash(false);
            });
    }, []);

    // Fetch city data
    useEffect(() => {
        setLoadingCity(true);
        myAxios
            .get(`get-city/${uid}/${cityPeriod}`)
            .then((res) => {
                setLoadingCity(false);
                setCity(res.data);
            })
            .catch((err) => {
                setLoadingCity(false);
                if (err.response?.data?.msg === 'No token, authorization denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('id');
                    localStorage.removeItem('IsSuper');
                    localStorage.removeItem('IsTeam');
                }
            });
    }, [cityPeriod]);

    // Fetch all period data
    useEffect(() => {
        const DashToday = () => {
            setLoadingDay(true);
            myAxios
                .get(`dash-today/${uid}`)
                .then((res) => {
                    setLoadingDay(false);
                    setDashToday(res.data);
                })
                .catch((err) => {
                    setLoadingDay(false);
                });
        };

        const DashYesterday = () => {
            setLoadingYes(true);
            myAxios
                .get(`dash-yesterday/${uid}`)
                .then((res) => {
                    setLoadingYes(false);
                    setDashYesterday(res.data);
                })
                .catch((err) => {
                    setLoadingYes(false);
                });
        };

        const DashMonth = () => {
            setLoadingMonth(true);
            myAxios
                .get(`dash-month/${uid}`)
                .then((res) => {
                    setLoadingMonth(false);
                    setDashMonth(res.data);
                })
                .catch((err) => {
                    setLoadingMonth(false);
                });
        };

        const DashLastMonth = () => {
            setLoadingLMonth(true);
            myAxios
                .get(`dash-last-month/${uid}`)
                .then((res) => {
                    setLoadingLMonth(false);
                    setDashLastMonth(res.data);
                })
                .catch((err) => {
                    setLoadingLMonth(false);
                });
        };

        DashToday();
        DashYesterday();
        DashMonth();
        DashLastMonth();
    }, []);

    // Fetch visitor data
    useEffect(() => {
        const VToday = () => {
            setloadingVDay(true);
            myAxios
                .get(`visitor-today/${uid}`)
                .then((res) => {
                    setloadingVDay(false);
                    setVisitToday(res.data);
                })
                .catch((err) => {
                    setloadingVDay(false);
                });
        };

        const VYesterday = () => {
            setloadingVYes(true);
            myAxios
                .get(`visitor-yesterday/${uid}`)
                .then((res) => {
                    setloadingVYes(false);
                    setVisitYesterday(res.data);
                })
                .catch((err) => {
                    setloadingVYes(false);
                });
        };

        const VMonth = () => {
            setloadingVMonth(true);
            myAxios
                .get(`visitor-month/${uid}`)
                .then((res) => {
                    setloadingVMonth(false);
                    setVistMonth(res.data);
                })
                .catch((err) => {
                    setloadingVMonth(false);
                });
        };

        const VLastMonth = () => {
            setloadingVLMonth(true);
            myAxios
                .get(`visitor-last-month/${uid}`)
                .then((res) => {
                    setloadingVLMonth(false);
                    setVisitLastMonth(res.data);
                })
                .catch((err) => {
                    setloadingVLMonth(false);
                });
        };

        VToday();
        VYesterday();
        VMonth();
        VLastMonth();
    }, []);

    // Fetch message data
    useEffect(() => {
        setLoadingMessage(true);
        myAxios
            .get(`get-message/${uid}`)
            .then((res) => {
                setLoadingMessage(false);
                setMessage(res.data);
            })
            .catch((err) => {
                setLoadingMessage(false);
            });
    }, []);

    // Fetch top selling products
    useEffect(() => {
        setLoadingTopSelling(true);
        myAxios
            .get(`dash-top-selling/${uid}`)
            .then((res) => {
                setLoadingTopSelling(false);
                if (res.data.success) {
                    setTopSelling(res.data.data || []);
                }
            })
            .catch((err) => {
                setLoadingTopSelling(false);
            });
    }, []);

    // Fetch low stock products
    useEffect(() => {
        setLoadingLowStock(true);
        myAxios
            .get(`dash-low-stock/${uid}`)
            .then((res) => {
                setLoadingLowStock(false);
                if (res.data.success) {
                    setLowStock(res.data.data || []);
                }
            })
            .catch((err) => {
                setLoadingLowStock(false);
            });
    }, []);

    const statsLoading = loadingDay || loadingYes || loadingMonth || loadingLMonth;

    const periods = [
        { label: 'Today', short: 'T', data: dashToday, color: '#5C6AC4' },
        { label: 'Yesterday', short: 'Y', data: dashYesterday, color: '#006FBB' },
        { label: 'This Month', short: 'M', data: dashMonth, color: '#108043' },
        { label: 'Last Month', short: 'LM', data: dashLastMonth, color: '#9C6ADE' },
    ];

    const allMetrics = [
        { label: 'Orders', key: 'sale', prefix: '', color: '#5C6AC4', gradient: 'linear-gradient(135deg, #5C6AC4, #7C8CF8)' },
        { label: 'Revenue', key: 'taka', prefix: '৳', color: '#006FBB', gradient: 'linear-gradient(135deg, #006FBB, #2E9BDA)' },
        { label: 'Profit', key: 'Profit', prefix: '৳', color: '#108043', gradient: 'linear-gradient(135deg, #108043, #2EAD66)' },
        { label: 'Return', key: 'Return', prefix: '', color: '#DE3618', gradient: 'linear-gradient(135deg, #DE3618, #F56342)' },
        { label: 'Advance', key: 'advance', prefix: '৳', color: '#47C1BF', gradient: 'linear-gradient(135deg, #47C1BF, #6DD8D6)' },
        { label: 'Discount', key: 'discount', prefix: '৳', color: '#9C6ADE', gradient: 'linear-gradient(135deg, #9C6ADE, #B794F4)' },
    ];

    const getBarHeight = (value, allValues) => {
        const max = Math.max(...allValues, 1);
        return Math.max((value / max) * 100, 6);
    };

    return (
        <div className={styles.dashboardWrapper}>
            {/* Metrics Grid - 3x2 with Vertical Bar Charts */}
            <div className={styles.metricsChartGrid}>
                {allMetrics.map((metric) => {
                    const values = periods.map((p) => p.data[metric.key] || 0);
                    // Headline = last 30 days. The four bars overlap (today and yesterday
                    // are inside this / last month), so adding them up double-counted.
                    const total = Number(dashMonth.last30?.[metric.key] ?? dashMonth[metric.key] ?? 0);
                    return (
                        <div key={metric.label} className={styles.metricChartCard}>
                            {statsLoading ? (
                                <div className={styles.skeletonChartCard}>
                                    <div className={styles.skeletonChartHeader}>
                                        <div>
                                            <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                                            <div className={`${styles.skeleton} ${styles.skeletonTotal}`}></div>
                                        </div>
                                        <div className={`${styles.skeleton} ${styles.skeletonBadge}`}></div>
                                    </div>
                                    <div className={styles.skeletonBars}>
                                        <div className={`${styles.skeleton} ${styles.skeletonBar}`} style={{ height: '60%' }}></div>
                                        <div className={`${styles.skeleton} ${styles.skeletonBar}`} style={{ height: '80%' }}></div>
                                        <div className={`${styles.skeleton} ${styles.skeletonBar}`} style={{ height: '45%' }}></div>
                                        <div className={`${styles.skeleton} ${styles.skeletonBar}`} style={{ height: '90%' }}></div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.metricChartHeader}>
                                        <div>
                                            <span className={styles.metricChartLabel}>{metric.label}</span>
                                            <div className={styles.metricChartTotal}>
                                                {metric.prefix}{total.toLocaleString()}
                                            </div>
                                            <div className={styles.metricChartSub}>last 30 days</div>
                                        </div>
                                        <div className={styles.metricChartBadge} style={{ background: metric.gradient }}>
                                            {metric.prefix}{(values[0]).toLocaleString()}
                                            <span className={styles.metricChartBadgeSub}>today</span>
                                        </div>
                                    </div>
                                    <div className={styles.verticalChart}>
                                        {periods.map((period, i) => (
                                            <div key={period.label} className={styles.vBarGroup}>
                                                <div className={styles.vBarValue}>
                                                    {metric.prefix}{values[i].toLocaleString()}
                                                </div>
                                                <div className={styles.vBarTrack}>
                                                    <div
                                                        className={styles.vBarFill}
                                                        style={{
                                                            height: `${getBarHeight(values[i], values)}%`,
                                                            background: metric.gradient,
                                                        }}
                                                    ></div>
                                                </div>
                                                <div className={styles.vBarLabel}>{period.short}</div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Top 5 Cities by Revenue Section */}
            <div className={styles.citiesCard}>
                <div className={styles.citiesCardHeader}>
                    <h2 className={styles.citiesCardTitle}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
                            <path d="M10 0C6.13 0 3 3.13 3 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#202223"/>
                        </svg>
                        Top 5 Cities by Revenue
                    </h2>
                    <select
                        className={styles.cityPeriod}
                        value={cityPeriod}
                        onChange={(e) => setCityPeriod(e.target.value)}
                        aria-label="Period"
                    >
                        <option value="30d">Last 30 days</option>
                        <option value="7d">Last 7 days</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="month">This month</option>
                        <option value="lastmonth">Last month</option>
                    </select>
                </div>
                <div className={styles.citiesCardBody}>
                    {LoadingCity ? (
                        <div className={styles.skeletonCities}>
                            {[1, 2, 3, 4, 5].map((n) => (
                                <div key={n} className={styles.skeletonCityRow}>
                                    <div className={`${styles.skeleton} ${styles.skeletonCityRank}`}></div>
                                    <div className={`${styles.skeleton} ${styles.skeletonCityName}`}></div>
                                    <div className={`${styles.skeleton} ${styles.skeletonCityBar}`}></div>
                                    <div className={`${styles.skeleton} ${styles.skeletonCityOrders}`}></div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className={styles.citiesList}>
                            {city.length > 0 ? (
                                city.slice(0, 5).map((data, index) => {
                                    const value = (d) => (d && d.revenue != null ? d.revenue : d?.orders || 0);
                                    const maxRevenue = Math.max(...city.slice(0, 5).map(value), 1);
                                    const percentage = Math.max((value(data) / maxRevenue) * 100, 4);

                                    return (
                                        <div className={styles.cityItem} key={index}>
                                            <div className={styles.cityRank}>#{index + 1}</div>
                                            <div className={styles.cityName}>{data.City}</div>
                                            <div className={styles.cityBarWrapper}>
                                                <div
                                                    className={styles.cityBar}
                                                    style={{ width: `${percentage}%` }}
                                                >
                                                    <span className={styles.cityRevenue}>
                                                        ৳ {Math.round(value(data)).toLocaleString('en-IN')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={styles.cityOrders}>{data.orders} orders</div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className={styles.emptyState}>No orders with a city in this period</div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Visitor & Message — Side by Side Compact Charts */}
            {(() => {
                const visitorLoading = loadingVDay || loadingVYes || loadingVMonth || loadingVLMonth;
                const visitorItems = [
                    { label: 'Today', value: VisitToday.today || 0, color: '#5C6AC4' },
                    { label: 'Yesterday', value: VisitYesterday.yesterday || 0, color: '#006FBB' },
                    { label: 'This Month', value: VistMonth.month || 0, color: '#108043' },
                    { label: 'Last Month', value: VisitLastMonth.lastMonth || 0, color: '#9C6ADE' },
                ];
                const visitorMax = Math.max(...visitorItems.map((v) => Number(v.value) || 0), 1);
                const visitorTotal = Number(VistMonth.last30 ?? VistMonth.month ?? 0); // last 30 days (the rows overlap)

                const messageItems = [
                    { label: 'Today', value: message.today || 0, color: '#47C1BF' },
                    { label: 'Yesterday', value: message.yesterday || 0, color: '#006FBB' },
                    { label: 'This Month', value: message.month || 0, color: '#DE3618' },
                    { label: 'Last Month', value: message.lastMonth || 0, color: '#FFC453' },
                ];
                const messageMax = Math.max(...messageItems.map((v) => Number(v.value) || 0), 1);
                const messageTotal = Number(message.last30 ?? message.month ?? 0); // last 30 days (the rows overlap)

                return (
                    <div className={styles.compactRow}>
                        {/* Visitors Card */}
                        <div className={styles.compactCard}>
                            {visitorLoading ? (
                                <div className={styles.compactSkeleton}>
                                    <div className={styles.compactSkeletonHeader}>
                                        <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                                        <div className={`${styles.skeleton} ${styles.skeletonTotal}`}></div>
                                    </div>
                                    <div className={styles.compactSkeletonBars}>
                                        {[65, 40, 85, 55].map((h, i) => (
                                            <div key={i} className={styles.compactSkeletonBarRow}>
                                                <div className={`${styles.skeleton}`} style={{ width: 70, height: 12 }}></div>
                                                <div className={`${styles.skeleton}`} style={{ flex: 1, height: 10, maxWidth: `${h}%` }}></div>
                                                <div className={`${styles.skeleton}`} style={{ width: 36, height: 12 }}></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.compactHeader}>
                                        <span className={styles.compactTitle}>Visitors</span>
                                        <span className={styles.compactTotal}>{visitorTotal.toLocaleString()}<small className={styles.compactSub}>last 30 days</small></span>
                                    </div>
                                    <div className={styles.compactBars}>
                                        {visitorItems.map((item) => (
                                            <div key={item.label} className={styles.compactBarRow}>
                                                <span className={styles.compactBarLabel}>{item.label}</span>
                                                <div className={styles.compactBarTrack}>
                                                    <div
                                                        className={styles.compactBarFill}
                                                        style={{
                                                            width: `${Math.max((Number(item.value) / visitorMax) * 100, 4)}%`,
                                                            backgroundColor: item.color,
                                                        }}
                                                    ></div>
                                                </div>
                                                <span className={styles.compactBarValue}>{Number(item.value).toLocaleString()}</span>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Messages Card */}
                        <div className={styles.compactCard}>
                            {loadingMessage ? (
                                <div className={styles.compactSkeleton}>
                                    <div className={styles.compactSkeletonHeader}>
                                        <div className={`${styles.skeleton} ${styles.skeletonLabel}`}></div>
                                        <div className={`${styles.skeleton} ${styles.skeletonTotal}`}></div>
                                    </div>
                                    <div className={styles.compactSkeletonBars}>
                                        {[50, 70, 35, 80].map((h, i) => (
                                            <div key={i} className={styles.compactSkeletonBarRow}>
                                                <div className={`${styles.skeleton}`} style={{ width: 70, height: 12 }}></div>
                                                <div className={`${styles.skeleton}`} style={{ flex: 1, height: 10, maxWidth: `${h}%` }}></div>
                                                <div className={`${styles.skeleton}`} style={{ width: 36, height: 12 }}></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.compactHeader}>
                                        <span className={styles.compactTitle}>Messages</span>
                                        <span className={styles.compactTotal}>{messageTotal.toLocaleString()}<small className={styles.compactSub}>last 30 days</small></span>
                                    </div>
                                    <div className={styles.compactBars}>
                                        {messageItems.map((item) => (
                                            <div key={item.label} className={styles.compactBarRow}>
                                                <span className={styles.compactBarLabel}>{item.label}</span>
                                                <div className={styles.compactBarTrack}>
                                                    <div
                                                        className={styles.compactBarFill}
                                                        style={{
                                                            width: `${Math.max((Number(item.value) / messageMax) * 100, 4)}%`,
                                                            backgroundColor: item.color,
                                                        }}
                                                    ></div>
                                                </div>
                                                <span className={styles.compactBarValue}>{Number(item.value).toLocaleString()}</span>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                );
            })()}

            {/* Inventory Statistics Grid - 2 cards */}
            <div className={styles.metricsGrid} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                {[
                    { value: dashboard.TotalInventory, label: 'Total Inventory' },
                    { value: `৳ ${dashboard.TotalInventoryValue || '0'}`, label: 'Inventory Value', raw: true },
                ].map((item) => (
                    <div key={item.label} className={styles.metricCard}>
                        <div className={styles.metricCardBody}>
                            {loadingDash ? (
                                <div className={styles.skeletonMetric}>
                                    <div className={`${styles.skeleton} ${styles.skeletonMetricValue}`}></div>
                                    <div className={`${styles.skeleton} ${styles.skeletonMetricLabel}`}></div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.metricValue}>{item.raw ? item.value : (item.value || '0')}</div>
                                    <div className={styles.metricLabel}>{item.label}</div>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Top Selling & Low Stock - Side by Side */}
            <div className={styles.compactRow}>
                {/* Top 5 Selling Items */}
                <div className={styles.listCard}>
                    <div className={styles.listCardHeader}>
                        <h3 className={styles.listCardTitle}>Top 5 Selling Items</h3>
                        <span style={{ display: 'block', marginTop: 2, fontSize: 12, color: '#6d7175' }} title="Real sales only: cancelled, returned, fake and your own test orders are not counted">Last 90 days</span>
                    </div>
                    <div className={styles.listCardBody}>
                        {loadingTopSelling ? (
                            <div className={styles.listSkeleton}>
                                {[1, 2, 3, 4, 5].map((n) => (
                                    <div key={n} className={styles.listSkeletonRow}>
                                        <div className={`${styles.skeleton}`} style={{ width: 40, height: 40, borderRadius: 8 }}></div>
                                        <div style={{ flex: 1 }}>
                                            <div className={`${styles.skeleton}`} style={{ width: '70%', height: 14, marginBottom: 6 }}></div>
                                            <div className={`${styles.skeleton}`} style={{ width: '40%', height: 12 }}></div>
                                        </div>
                                        <div className={`${styles.skeleton}`} style={{ width: 50, height: 14 }}></div>
                                    </div>
                                ))}
                            </div>
                        ) : topSelling.length > 0 ? (
                            <div className={styles.productList}>
                                {topSelling.map((item, index) => (
                                    <div key={item._id} className={styles.productItem}>
                                        <span className={styles.productRank}>#{index + 1}</span>
                                        <div className={styles.productImage}>
                                            {item.image ? (
                                                <img src={item.image} alt={item.name} />
                                            ) : (
                                                <div className={styles.productImagePlaceholder}>N/A</div>
                                            )}
                                        </div>
                                        <div className={styles.productInfo}>
                                            <div className={styles.productName}>{item.name}</div>
                                            <div className={styles.productPrice}>৳ {item.price}</div>
                                        </div>
                                        <div className={styles.productSold}>{item.sold} sold</div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.emptyState}>No sales data available</div>
                        )}
                    </div>
                </div>

                {/* Low Inventory Alert */}
                <div className={styles.listCard}>
                    <div className={styles.listCardHeader}>
                        <h3 className={styles.listCardTitle}>
                            Low Inventory Alert
                            {!loadingLowStock && lowStock.length > 0 && (
                                <span className={styles.alertBadge}>{lowStock.length}</span>
                            )}
                        </h3>
                    </div>
                    <div className={styles.listCardBody}>
                        {loadingLowStock ? (
                            <div className={styles.listSkeleton}>
                                {[1, 2, 3, 4, 5].map((n) => (
                                    <div key={n} className={styles.listSkeletonRow}>
                                        <div className={`${styles.skeleton}`} style={{ width: 40, height: 40, borderRadius: 8 }}></div>
                                        <div style={{ flex: 1 }}>
                                            <div className={`${styles.skeleton}`} style={{ width: '70%', height: 14, marginBottom: 6 }}></div>
                                            <div className={`${styles.skeleton}`} style={{ width: '40%', height: 12 }}></div>
                                        </div>
                                        <div className={`${styles.skeleton}`} style={{ width: 50, height: 14 }}></div>
                                    </div>
                                ))}
                            </div>
                        ) : lowStock.length > 0 ? (
                            <div className={styles.productList}>
                                {lowStock.map((item) => (
                                    <div key={item._id} className={styles.productItem}>
                                        <div className={styles.stockIndicator} style={{
                                            backgroundColor: item.stock === 0 ? '#DE3618' : item.stock <= 2 ? '#FFC453' : '#F4A261'
                                        }}></div>
                                        <div className={styles.productImage}>
                                            {item.image ? (
                                                <img src={item.image} alt={item.name} />
                                            ) : (
                                                <div className={styles.productImagePlaceholder}>N/A</div>
                                            )}
                                        </div>
                                        <div className={styles.productInfo}>
                                            <div className={styles.productName}>{item.name}</div>
                                            <div className={styles.productPrice}>৳ {item.price}</div>
                                        </div>
                                        <div className={`${styles.stockBadge} ${item.stock === 0 ? styles.stockOut : styles.stockLow}`}>
                                            {item.stock === 0 ? 'Out of stock' : `${item.stock} left`}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={styles.emptyState}>All products are well stocked</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
